import dayjs from 'dayjs';

export const getFormattedTime = (date: Date): string => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '--:--';
  }

  return `${dayjs(date).format('HH:mm')}`;
};
